"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncateString = void 0;
const truncate = require("truncate-utf8-bytes");
const constants_1 = require("./constants");
const getStringSize_1 = require("./getStringSize");
/**
 * @param {number} sizeLimit — The resulting string will not exceed `sizeLimit` bytes.
 */
const truncateString = (str, sizeLimit) => {
    if (typeof str !== 'string' || (0, getStringSize_1.getStringSize)(str) <= sizeLimit) {
        return str;
    }
    return sizeLimit < (0, getStringSize_1.getStringSize)(constants_1.ELLIPSIS_CHAR)
        ? ''
        : `${truncate(str, sizeLimit - (0, getStringSize_1.getStringSize)(constants_1.ELLIPSIS_CHAR))}${constants_1.ELLIPSIS_CHAR}`;
};
exports.truncateString = truncateString;
//# sourceMappingURL=truncateString.js.map